import type { BookingUnit } from '@shared/types/restaurants';

/**
 * The seat/table word for an event's booking unit, in the three forms the
 * booking flow needs. Events sold by seat must never mention tables to guests,
 * and vice versa, so every guest-facing unit word comes from here.
 */
export const getBookingUnitLabels = (bookingUnit: BookingUnit) => {
  const unitLabel = bookingUnit;

  return {
    // "seat" / "table"
    unitLabel,
    // "seats" / "tables"
    unitLabelPlural: `${unitLabel}s`,
    // "Seat" / "Table"
    unitLabelCapitalized:
      unitLabel.charAt(0).toUpperCase() + unitLabel.slice(1),
  };
};
